<template>
  <div class="ma-0 pa-0" style="height: 90vh; overflow: hidden">
    <Navigation />
    <v-row class="justify-end">
      <v-col style="max-width: calc(100% - 56px)" class="px-5">
        <div
          class="card_container mx-auto d-flex justify-space-between mt-4 mb-n2"
        >
          <toolbar-titles
            :title="$tc('gestionEmpleados.employees')"
          ></toolbar-titles>
          <!------------------BOTONES DE ATRAS ADELANTE----------------------->
          <div>
            <v-btn
              color="info"
              text
              class="pl-0"
              @click="previous()"
              :disabled="disabledPrevious"
            >
              <v-img
                src="../../../../assets/icons/anterior.png"
                style="cursor: pointer"
                alt="anterior"
                max-width="30"
                max-height="30"
                dark
              />{{ $tc("gestionEmpleados.previous") }}
            </v-btn>
            <v-btn
              color="info"
              text
              @click="next()"
              :disabled="disabledNext"
              class="pr-0"
              >{{ $tc("gestionEmpleados.next") }}
              <v-img
                src="../../../../assets/icons/siguiente.png"
                style="cursor: pointer"
                alt="siguiente"
                max-width="30"
                max-height="30"
                dark
              />
            </v-btn>
          </div>
        </div>
        <v-dialog max-width="500px" v-model="showAlert">
          <v-card max-width="500px">
            <v-card-title style="display: flex; justify-content: center"
              >{{ $tc("gestionEmpleados.editEmployed") }}
            </v-card-title>
            <div style="display: flex; justify-content: center">
              <v-btn class="bt-exit mr-2 mb-2" @click="showAlert = false"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn class="bt-acept" @click="save">
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </v-card>
        </v-dialog>
        <div class="pa-0 mt-0 pa-0">
          <v-card
            class="d-flex overflow-y-auto pa-0 ma-0 card_container mx-auto"
            max-height="6s00px"
          >
            <v-form
              @submit.prevent="alertEdit"
              ref="form"
              v-model="valid"
              class="flex-grow-1"
            >
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-row class="ma-0 pa-0">
                <v-col cols="12" sm="12" md="2">
                  <div class="img">
                    <v-avatar size="130">
                      <v-img
                        max-height="130"
                        max-width="130"
                        :src="currentFormData.preview"
                        v-if="currentFormData.preview"
                        :class="showSave ? 'img-blur' : ''"
                        @click="showSave ? $refs.fileInput.click() : null"
                      >
                      </v-img>

                      <img
                        src="../../../../assets/avatar.png"
                        alt="user"
                        v-else
                        :class="showSave ? 'img-blur' : ''"
                        @click="showSave ? $refs.fileInput.click() : null"
                      />
                    </v-avatar>
                    <input
                      style="display: none"
                      type="file"
                      @change="(event) => handleChange(event, 'vistaPrevia')"
                      ref="fileInput"
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="10">
                  <v-row class="ma-0">
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="currentFormData.name"
                        @change="(event) => handleChange(event, 'nombres')"
                        :label="$tc('gestionEmpleados.name')"
                        :disabled="disabledItems"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="currentFormData.lastName"
                        @change="(event) => handleChange(event, 'apellido')"
                        :label="$tc('gestionEmpleados.lastName')"
                        :disabled="disabledItems"
                        outlined
                        dense
                        filled
                        hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" sm="6" md="6" class="d-flex d-inline-flex">
                      <v-select
                        hide-details
                        outlined
                        dense
                        filled
                        :items="doc"
                        class="mr-2"
                        :label="$tc('gestionEmpleados.typeDoc')"
                        v-model="currentFormData.typeDoc"
                        :disabled="disabledItems"
                        style="max-width: 110px"
                        @change="(event) => handleChange(event, 'tdoc')"
                      />
                      <v-text-field
                        v-model="currentFormData.numDoc"
                        :label="$tc('gestionEmpleados.numDoc')"
                        :disabled="disabledItems"
                        outlined
                        dense
                        filled
                        @change="(event) => handleChange(event, 'ndoc')"
                        :rules="numDocRules"
                        :hide-details="valid"
                      />
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="currentFormData.file"
                        @change="(event) => handleChange(event, 'legajo')"
                        :label="$tc('gestionEmpleados.file')"
                        :disabled="disabledItems"
                        outlined
                        dense
                        filled
                        hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" sm="6" md="6">
                      <v-menu
                        ref="endMenuCalendar"
                        v-model="endMenuCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-bind="attrs"
                            v-on="on"
                            v-model="formatHighDay"
                            :label="$tc('gestionEmpleados.high')"
                            :disabled="disabledItems"
                            outlined
                            dense
                            filled
                            hide-details
                          />
                        </template>
                        <v-date-picker
                          v-model="changeDateHigh"
                          @input="endMenuCalendar = false"
                          locale="es-es"
                          @change="(event) => handleChange(event, 'fecAlta')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="d-flex d-inline-flex">
                      <v-menu
                        ref="menuCalendarDown"
                        v-model="menuCalendarDown"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-bind="attrs"
                            v-on="on"
                            v-model="formatDownDay"
                            :label="$tc('gestionEmpleados.down')"
                            :disabled="disabledItems || currentFormData.baNoEx"
                            outlined
                            dense
                            filled
                            style="width: 200px"
                            hide-details
                          />
                        </template>
                        <v-date-picker
                          v-model="changeDateDown"
                          @input="menuCalendarDown = false"
                          @change="(event) => handleChange(event, 'fecBaja')"
                          locale="es-es"
                        >
                        </v-date-picker>
                      </v-menu>

                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-simple-checkbox
                              class="my-2 ml-2 mr-n2"
                              :disabled="disabledItems"
                              :ripple="false"
                              color="accent"
                              v-model="currentFormData.baNoEx"
                              @input="(event) => handleChange(event, 'baNoEx')"
                            >
                            </v-simple-checkbox>
                          </span>
                        </template>
                        <span>{{ $tc("changeSchedule.caducity") }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mx-3 mt-3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          dense
                          color="info"
                          @click="editEmployed"
                          v-show="showEdit"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="
                            !verifyExistingAction('accion:editarempleado')
                          "
                        >
                          <v-img
                            src="../../../../assets/icons/editar.png"
                            alt="editar"
                            max-width="25"
                          />
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          dense
                          @click="cancelEdit"
                          v-show="showSave"
                          class="bt-exit"
                        >
                          cancelar
                        </v-btn>
                      </template>
                      <span>Cancelar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          dense
                          class="bt-acept ml-2"
                          @click="alertEdit"
                          v-show="showSave"
                        >
                          {{ $tc("filter.save") }}</v-btn
                        >
                      </template>
                      <span>Guardar</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <Alerts :alert="alertOk" :color="colorOk" :textAlert="textAlertOk" />
    <Alerts
      :alert="alertError"
      :color="colorError"
      :textAlert="textAlertError"
    />
  </div>
</template>

<script>
import Navigation from "./Navigation.vue";
import moment from "moment";
import Alerts from "../../commons/Alerts.vue";
import ToolbarTitles from "../../../Complement/ToolbarTitles.vue";

export default {
  components: { Navigation, Alerts, ToolbarTitles },
  data() {
    return {
      showAlert: false,
      alertOk: false,
      alertError: false,
      colorOk: "#82A1D0",
      colorError: "#FF8D58",
      textAlertOk: this.$tc("gestionEmpleados.okEmployed"),
      textAlertError: this.$tc("gestionEmpleados.errorEmployed"),
      endMenuCalendar: false,
      menuCalendarDown: false,
      disabledNext: false,
      disabledPrevious: false,
      disabledItems: true,
      showSave: false,
      showEdit: true,
      doc: ["DNI", "CUIL"],
      currentFormData: { ...this.$store.state.employees.itemsEmployed },
      oldFormData: this.$store.state.employees.itemsEmployed,
      changedFields: {},
      alertNotChange: false,
      change: null,
      selectedFile: null,
      oldData: {},
      valid: true,
      error: false,
      alertValidate: "",
    };
  },

  mounted() {
    this.disabledButtons();
    this.initialDate();
    document.addEventListener("keydown", this.handleEscKey);
  },
  destroyed() {
    document.removeEventListener("keydown", this.handleEscKey);
  },

  computed: {
    changeDateHigh: {
      get: function () {
        return this.$store.state.employees.dateHigh;
      },
      set: function (newDate) {
        if (newDate > this.$store.state.employees.dateDown) {
          this.setDateDown(newDate);
        }
        this.setDateHigh(newDate);
      },
    },
    changeDateDown: {
      get: function () {
        return this.$store.state.employees.dateDown;
      },
      set: function (date) {
        if (date < this.$store.state.employees.dateHigh) {
          this.setDateHigh(date);
        }
        this.setDateDown(date);
      },
    },
    formatHighDay: {
      get() {
        return moment(this.changeDateHigh).format("DD-MM-YYYY");
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },
    formatDownDay: {
      get() {
        let date = moment(this.changeDateDown).format("DD-MM-YYYY");
        return this.changeDateDown === null ? this.changeDateDown : date;
      },
      set(newValue) {
        return moment(newValue).format("DD-MM-YYYY");
      },
    },
    numDocRules() {
      return [
        (value) => {
          if (this.currentFormData.typeDoc === "DNI") {
            if (!value || value.length !== 8) {
              return this.$tc("gestionEmpleados.rulesDni");
            }
          } else {
            if (!value || value.length !== 11) {
              return this.$tc("gestionEmpleados.rulesCuil");
            }
          }
          return true;
        },
      ];
    },
  },
  methods: {
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
    editEmployed() {
      this.disabledItems = false;
      this.showSave = true;
      this.showEdit = false;
    },
    handleEscKey(event) {
      if (event.key === "Escape") {
        // Redirigir al usuario a la ruta "/gestionEmpleados"
        this.$router.push("/gestionEmpleados");
      }
    },
    alertEdit() {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.change == undefined) {
          this.error = true;
          this.alertValidate = this.$tc("gestionEmpleados.alertChange");
          setTimeout(() => {
            this.error = false;
          }, 5000);
        } else {
          this.showAlert = true;
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleChange(changedField, type) {
      if (type === "fecBaja") {
        changedField = moment(changedField).format("YYYY-MM-DD");
      }
      this.change = changedField;
      const previousPreview = this.currentFormData.preview;
      if (type == "vistaPrevia") {
        const file = document.querySelector("input[type=file]").files[0];
        const reader = new FileReader();

        let rawImg;
        reader.onloadend = () => {
          rawImg = reader.result;
          this.selectedFile = rawImg;
          this.currentFormData.preview = rawImg;
          const payload = {
            vistaPrevia: this.selectedFile,
          };
          this.$store.commit("employees/setEditEmployed", payload);

          this.$store
            .dispatch("employees/edit")
            .then(() => {})
            .catch((e) => {
              this.currentFormData.preview = previousPreview;
              this.alertError = true;
              this.showAlert = false;
            });
        };

        reader.readAsDataURL(file);
      }
      if (type == "fecAlta" || type == "fecBaja") {
        Object.assign(this.changedFields, {
          [type]: changedField + "T00:00:00.000Z",
        });
      } else {
        Object.assign(this.changedFields, { [type]: changedField });
      }
    },
    save() {
      this.disabledItems = true;
      this.showSave = false;
      this.showEdit = true;

      if (this.selectedFile) {
        this.changedFields = {
          ...this.changedFields,
          vistaPrevia: this.selectedFile,
        };
      }

      const parsedChangedFields = {};
      Object.keys(this.changedFields).forEach((key) => {
        switch (key) {
          case "fecBaja":
            parsedChangedFields.downDate = this.changedFields[key].replace(
              "T00:00:00.000Z",
              ""
            );
            break;
          case "vistaPrevia":
            parsedChangedFields.preview = this.changedFields[key];
            break;
          case "fecAlta":
            parsedChangedFields.highDate = this.changedFields[key];
            break;
          case "legajo":
            parsedChangedFields.file = this.changedFields[key];
            break;
          case "tdoc":
            parsedChangedFields.typeDoc = this.changedFields[key];
            break;
          case "ndoc":
            parsedChangedFields.numDoc = this.changedFields[key];
            break;
          case "apellido":
            parsedChangedFields.lastName = this.changedFields[key];
            break;
          case "nombres":
            parsedChangedFields.name = this.changedFields[key];
            break;
          case "baNoEx":
            parsedChangedFields.haNoEx = this.changedFields[key];
            parsedChangedFields.downDate = null;
            break;
          default:
            break;
        }
      });

      this.$store.commit("employees/setItemsEmployed", {
        ...this.$store.state.employees.itemsEmployed,
        ...parsedChangedFields,
      });
      this.$store.commit("employees/setEditEmployed", this.changedFields);

      this.refreshItems();

      this.$store
        .dispatch("employees/edit")
        .then(() => {
          this.oldFormData = { ...this.currentFormData };
          this.showAlert = false;
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.showAlert = false;
        });
    },
    next() {
      let items = this.$store.state.employees.employees;

      let itemNext;
      for (let i = 0; i < items.length; i++) {
        if (items[i].empId === this.currentFormData.empId) {
          itemNext = items[i + 1];
        }
      }

      this.viewEmployed(itemNext);
    },
    previous() {
      let items = this.$store.state.employees.employees;

      let itemPrevious;
      for (let i = 0; i < items.length; i++) {
        if (items[i].empId === this.currentFormData.empId) {
          this.$store.commit("employees/setDateHigh", items[i - 1].highDate);
          this.$store.commit("employees/setDateDown", items[i - 1].downDate);
          itemPrevious = items[i - 1];
        }
      }

      this.viewEmployed(itemPrevious);
    },

    viewEmployed(item) {
      const copia = { ...item };
      this.currentFormData = copia;

      localStorage.setItem("empId", item.empId);
      this.$store.commit("employees/setItemsEmployed", copia);
      this.oldFormData = { ...this.currentFormData };

      this.disabledNext = false;
      this.disabledPrevious = false;
      this.disabledButtons();
      this.$router.push(`/gestionEmpleados/info/${item.empId}`);
    },

    disabledButtons() {
      let items = this.$store.state.employees.employees;
      if (this.currentFormData.empId == items[0].empId) {
        this.disabledPrevious = true;
      }

      if (this.currentFormData.empId == items[items.length - 1].empId) {
        this.disabledNext = true;
      }
    },
    cancelEdit() {
      this.$refs.form.resetValidation();

      if (
        this.$store.state.employees.itemsEmployed.downDate == null &&
        this.changedFields.fecBaja
      ) {
        this.changeDateDown = null;
      }
      this.currentFormData = { ...this.oldFormData };

      this.initialDate();

      this.disabledItems = true;
      this.showSave = false;
      this.showEdit = true;
    },
    initialDate() {
      this.$store.commit(
        "employees/setDateHigh",
        this.$store.state.employees.itemsEmployed.highDate
      );
      this.$store.commit(
        "employees/setDateDown",
        this.$store.state.employees.itemsEmployed.downDate
      );
    },

    setDateHigh(date) {
      this.$store.commit("employees/setDateHigh", date);
    },
    setDateDown(date) {
      this.$store.commit("employees/setDateDown", date);
    },

    handleChangePhoto(event) {
      this.selectedFile = event.target.files[0].name;
    },
    refreshItems() {
      const updatedItem = this.$store.state.employees.itemsEmployed;
      let allEmployees = this.$store.state.employees.orderEmployees;
      let indice;

      // tengo los elementos y el indice del empleado actual
      allEmployees.forEach((element, index) => {
        if (element.empId === updatedItem.empId) {
          indice = index;
        }
      });

      allEmployees[indice] = updatedItem;
      this.$store.commit("employees/setOrderEmployees", allEmployees);
    },
    refreshEmployee() {},
  },
};
</script>

<style scoped>
.img-blur:hover {
  opacity: 0.5;
  cursor: pointer;
}

.img {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.title-class {
  color: #586271;
  font-weight: lighter !important;
  margin-bottom: 20px !important;
  text-shadow: 1px 1px #384b6d;
}
.card__ {
  display: flex !important;
  flex-direction: row !important;
}

.card_container {
  max-width: 1500px !important;
}

.button__cancel {
  background-color: #a8a8a8 !important;
}

.button__edit {
  display: flex !important;
  justify-content: flex-end !important;
}
</style>
